import type { FC } from 'react'

import { Radio, RadioGroup, Checkbox } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'
import { useOffBoardingForm } from '@/forms/hooks'

import './termination-type.scss'

export const TerminationType: FC = () => {
  const { data } = useOffBoardingForm()

  return (
    <section className="termination-type">
      <h3>
        <Text id="Oppsigelsesform" />
      </h3>

      <RadioGroup id="termination-type">
        <Field name="terminationType">
          {({ field, form }: FieldProps) => (
            <Radio
              id="CANCELLATION"
              label={<Text id="Abonnementet skal sies opp i sin helhet" />}
              marginBottom={16}
              isDisabled={!data.isEditable}
              onFieldChange={() => {
                if (!form.values.isCreditCheckAccepted) return
                form.setFieldValue('isCreditCheckAccepted', false)
                form.setFieldTouched('isCreditCheckAccepted', false)
              }}
              {...field}
            />
          )}
        </Field>

        <Field name="terminationType">
          {({ field, meta }: FieldProps) => (
            <Radio
              id="TRANSFER"
              label={<Text id="Ønsker å ta med mobilnummeret" />}
              marginBottom={16}
              isDisabled={!data.isEditable}
              error={meta.error}
              touched={meta.touched}
              {...field}
            />
          )}
        </Field>
      </RadioGroup>

      <Acceptance />
    </section>
  )
}

const Acceptance: FC = () => {
  const { data } = useOffBoardingForm()

  return (
    <Field name="isCreditCheckAccepted" type="checkbox">
      {({ field, form, meta }: FieldProps) => {
        if (form.values.terminationType !== 'TRANSFER') return null

        return (
          <div className="credit-check-acceptance">
            <Checkbox
              id="isCreditCheckAccepted"
              label={
                <Text id="Jeg samtykker i at operatør kan utføre en kredittsjekk og at jeg er ansvarlig for kostnader etter at abonnementet er overført til meg." />
              }
              checked={field.value}
              error={meta.error}
              touched={meta.touched}
              isDisabled={!data.isEditable}
              {...field}
            />
          </div>
        )
      }}
    </Field>
  )
}
